export var KEY = '---------';

/**
 * @returns {object}
 */
export default function separatorItem() {
  return {
    name: KEY
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/contextMenu/predefinedItems/separator.mjs
// module id = 266
// module chunks = 1